import actionTypes from './actionTypes';

const requestMilestones = (args) => ({
    type: actionTypes.REQUEST_MILESTONES,
    gameTypeId: args,
});

const milestonesResponse = (success, errors, response) => ({
    type: actionTypes.MILESTONES_RESPONSE,
    payload: {
        success,
        errors,
        response,
    },
});

export default {
    requestMilestones,
    milestonesResponse,
};
